import Vue from 'vue';
import VueSlickCarousel from 'vue-slick-carousel';

//vue-slick-carousel styles
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

Vue.component("VueSlickCarousel", VueSlickCarousel);